export const isReceiptTransaction = (transaction) => {
  const ext = transaction?.external_txn_id && String(transaction.external_txn_id);
  return !!(ext && ext.startsWith('receipt-'));
};

export const getSchoolRevenue = (transaction) => {
  const commission = Number(transaction?.commission_amount) || 0;
  if (!commission) return 0;
  const split = transaction?.school_commission_split ?? 0.7;
  return commission * split;
};

export const getHcRevenue = (transaction) => {
  if (isReceiptTransaction(transaction)) return 0;
  const commission = Number(transaction?.commission_amount) || 0;
  if (!commission) return 0;
  const split = transaction?.school_commission_split ?? 0.7;
  return commission * (1 - split);
};

/**
 * Transaction status filtering, shared by the transaction dashboards.
 *
 * Three statuses carry a vendor commission with no sale standing behind it:
 * `failed` (the purchase never completed), and `refunded` / `voided` (it was
 * reversed afterwards). Olive reports the reward line regardless, so counting
 * any of them inflates revenue and, on the billing side, invoices merchants for
 * money they never took. All three are out by default; the dropdown exists to
 * look at them deliberately, not to include them by accident.
 */

export const NON_BILLABLE_STATUSES = ['failed', 'refunded', 'voided'];

export const EXCLUDE_NON_BILLABLE = 'exclude_non_billable';

export const isNonBillableTxn = (transaction) =>
  NON_BILLABLE_STATUSES.includes(String(transaction?.status || '').toLowerCase());

// Mirrors Transaction.STATUS_CHOICES in apps/core/models.py.
export const STATUS_FILTER_OPTIONS = [
  { value: EXCLUDE_NON_BILLABLE, label: 'All except failed, refunded & voided' },
  { value: 'all', label: 'All statuses' },
  { value: 'auth', label: 'Authorized' },
  { value: 'captured', label: 'Captured' },
  { value: 'refunded', label: 'Refunded' },
  { value: 'voided', label: 'Voided' },
  { value: 'failed', label: 'Failed' },
];

export const matchesStatusFilter = (transaction, filter) => {
  if (filter === 'all') return true;
  if (filter === EXCLUDE_NON_BILLABLE) return !isNonBillableTxn(transaction);
  return String(transaction?.status || '').toLowerCase() === filter;
};
